import React from 'react'
import styled from 'styled-components'
import { MobileView } from 'react-device-detect'

// components
import { ScrollToTop } from '../../components'

// globals
import * as constants from '../../globals/constants'

// utils
import { getLastPath } from '../../utils/getLastPath'

// styles
import colors from '../../styles/colors'

const Footer = ({ isTerm }) => {
  // 대시보드
  const isDashboard = getLastPath(window.location.pathname) === ''

  // 대시보드, 주문관리, 공지사항 페이지
  const isBig =
    isDashboard ||
    getLastPath(window.location.pathname).includes(
      constants.CURRENT_URL.ORDER_LIST,
    ) ||
    getLastPath(window.location.pathname).includes(
      constants.CURRENT_URL.NOTICE_HAPPY_ORDER,
    )

  const onClickFooter = (flag) => {
    switch (flag) {
      //서비스 이용약관
      case 0:
        window.open(`${constants.CURRENT_URL.SERVICE_TERMS}`, 'service_page')
        break

      // 개인정보처리방침
      case 1:
        window.open(`${constants.CURRENT_URL.PRIVACY_TERMS}`, 'privacy_page')

        break

      default:
        break
    }
  }

  if (isTerm) {
    return <></>
  } else {
    return (
      <>
        <FillContainer />
        <Container isBig={isBig} isDashboard={isDashboard}>
          <MobileView>
            <NonRemoteTxt>
              *원격지원 서비스 필요 시 PC버전으로 이용해주세요.
            </NonRemoteTxt>
          </MobileView>
          <HeaderWrapper>(주)섹타나인</HeaderWrapper>
          <BodyWrapper>
            <TopInfoWrapper>
              <RepresentativeAndSalesWrapper>
                <RepresentativeAndCompanyNumber isDashboard={isDashboard}>
                  <div>
                    <span>{`대표이사 : 김대일`}</span>
                    <span>{` ㅣ `}</span>
                  </div>

                  <div>
                    <span>{`사업자등록번호 : 214-85-54039`}</span>
                    <span>{` ㅣ `}</span>
                  </div>
                </RepresentativeAndCompanyNumber>

                <SalesNumber>
                  <div>
                    <span>{`통신판매업 신고번호 : 2015-경기성남-1705`}</span>
                    <span>{` ㅣ `}</span>
                  </div>
                </SalesNumber>
              </RepresentativeAndSalesWrapper>

              <AddressWrapper>
                <div>
                  <span>{`주소 : 서울특별시 강남구 논현로 201(빌딩명:SPC 2023)`}</span>
                  <span>{` ㅣ `}</span>
                </div>
              </AddressWrapper>
            </TopInfoWrapper>
            <BotInfoWrapper>
              <CustomerService>
                <div>
                  <span>{`고객센터 : 1670-3131`}</span>
                  <span>{` ㅣ `}</span>
                </div>
              </CustomerService>
              <Email>
                <div>
                  <span>{`이메일 : shopmaster@spc.co.kr`}</span>
                </div>
              </Email>
            </BotInfoWrapper>
          </BodyWrapper>

          <TermWrapper>
            <div onClick={() => onClickFooter(0)}>서비스 이용약관</div>
            <span>{`ㅣ`}</span>
            <div onClick={() => onClickFooter(1)}>개인정보처리방침</div>
          </TermWrapper>

          <ScrollToTop right={0} bot={[0, 0]} />
        </Container>
      </>
    )
  }
}

export default Footer

const FillContainer = styled.div`
  flex: 1;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 158px 0 19px;
  width: 100%;
  /* max-width: 984px; */
  max-width: ${(props) => (props.isBig ? '984px' : '768px')};
  align-self: center;

  /* padding: 0 20px; */
  position: relative;

  @media ${(props) => props.theme.tablet} {
    margin: 43px 0 19px;
  }

  @media (max-width: 800px) {
    max-width: ${(props) => props.isDashboard && '482px;'};
  }

  @media ${(props) => props.theme.mobile} {
    margin: 53px 0 19px;
    padding: 0 20px;
  }
`

const HeaderWrapper = styled.div`
  display: flex;
  font-size: 12px;
  font-weight: 700;
  color: ${colors.BK};
  margin-bottom: 12px;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
`

const TopInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  span:nth-child(1) {
    color: ${colors.G4};
  }

  span:nth-child(2) {
    color: ${colors.G3};
  }

  @media (max-width: 1150px) {
    flex-direction: column;
  }

  @media (max-width: 880px) {
    flex-direction: column;
  }
`

const RepresentativeAndSalesWrapper = styled.div`
  display: flex;

  @media (max-width: 650px) {
    flex-direction: column;
  }
`

const RepresentativeAndCompanyNumber = styled.div`
  display: flex;

  margin-bottom: 6px;

  div {
    display: flex;
  }

  div:nth-child(1) {
    @media (max-width: 650px) {
      margin-bottom: 6px;
    }
  }

  span:nth-child(2) {
    /* display: ${(props) => props.isDashboard && 'none'}; */
  }

  @media (max-width: 650px) {
    flex-direction: column;
  }
`

const SalesNumber = styled.div`
  display: flex;

  margin-bottom: 6px;
`

const AddressWrapper = styled.div`
  display: flex;

  margin-bottom: 6px;

  div {
    display: flex;
  }

  span:nth-child(2) {
    /* display: none; */
  }

  /* @media ${(props) => props.theme.mobile} {
    span:nth-child(2) {
      display: block;
    }
  } */
`

const BotInfoWrapper = styled.div`
  display: flex;

  span:nth-child(1) {
    color: ${colors.G4};
  }

  span:nth-child(2) {
    color: ${colors.G3};
  }
`

const CustomerService = styled.div`
  /* @media ${(props) => props.theme.mobile} {
    span:nth-child(1) {
      display: none;
    }
  } */
`

const Email = styled.div``

const TermWrapper = styled.div`
  margin-top: 15px;
  display: flex;
  align-items: center;

  div {
    font-size: 15px;
    color: ${colors.G4};
    cursor: pointer;
  }

  div:nth-child(1) {
  }

  span {
    font-size: 14px;
    color: #d8d8d8;
    margin: 0 6px;
  }

  div:nth-child(3) {
    font-weight: bold;
  }
`
const NonRemoteTxt = styled.p`
  font-size: 16px;
  color: ${colors.G4};
  margin-bottom: 30px;
`
